import { ComparePage } from '@/components/marketing/compare-page'

export function ComparePerplexityPage() {
  return (
    <ComparePage
      contentKey="comparePerplexity"
      path="/compare/perplexity"
      otherLabel="Perplexity"
      relatedKeys={['compareNotebooklm', 'whatIsKnowledgeGraph', 'useCasesResearchers']}
    />
  )
}
